import apiSlice from "./apiSlice";

const keyScheduleSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({

        // Get All Schedule
        getAllSchedule: builder.query({
            query: (params) => ({
                url: `Schedule`,
                params
            }),
            providesTags: ["ScheduleList"],
        }),

    }),
});

export default keyScheduleSlice;

export const {
    useGetAllScheduleQuery, 
} = keyScheduleSlice;